import { forwardRef, HTMLAttributes, ReactNode } from "react";
import { cn } from "../../lib/utils";

interface BookingFlowLayoutProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

interface BookingFlowLayoutMainProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

interface BookingFlowLayoutSidebarProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

const BookingFlowLayout = forwardRef<HTMLDivElement, BookingFlowLayoutProps>(
  ({ className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "booking-flow-layout flex flex-col lg:flex-row gap-8 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  ),
);
BookingFlowLayout.displayName = "BookingFlowLayout";

const BookingFlowLayoutMain = forwardRef<
  HTMLDivElement,
  BookingFlowLayoutMainProps
>(({ className, children, ...props }, ref) => (
  <main
    ref={ref}
    className={cn(
      "booking-flow-main flex-1 min-w-0 pointer-events-auto",
      className,
    )}
    {...props}
  >
    {children}
  </main>
));
BookingFlowLayoutMain.displayName = "BookingFlowLayoutMain";

const BookingFlowLayoutSidebar = forwardRef<
  HTMLDivElement,
  BookingFlowLayoutSidebarProps
>(({ className, children, ...props }, ref) => (
  <aside
    ref={ref}
    className={cn(
      "booking-flow-sidebar w-full lg:w-[400px] shrink-0 pointer-events-auto",
      className,
    )}
    {...props}
  >
    {children}
  </aside>
));
BookingFlowLayoutSidebar.displayName = "BookingFlowLayoutSidebar";

export { BookingFlowLayout, BookingFlowLayoutMain, BookingFlowLayoutSidebar };
